import Layout from "Layout";
import { Helmet } from "react-helmet-async";
import { Tabs, Modal, Radio, ConfigProvider } from 'antd';
import type { TabsProps } from 'antd';
import type { CheckboxGroupProps } from 'antd/es/checkbox';
import StoreInventoryItem from "./component/inventoryItemList";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import InventoryBuyHistory from "./component/inventoryBuyHistoryItem";
import { t } from "i18next";

// @ts-ignore: Allow importing SCSS modules without type declarations
import './inventory.scss';

interface OrderItemType {
    id: number;
    created_at: string;
    updated_at?: string;
    points_paid?: number;
    points_paid_formatted?: string;
    product_id?: number | null;
    status?: string;
    tool_id?: number | null;
    name?: string;
    image?: string;
    platform?: string;
    download_url?: string;
}



const StoreUserInventory = () => {
    const { t } = useTranslation();
    const [selectedTab, setSelectedTab] = useState('MyProducts');
    const handleTabChange = (key: string) => {
        setSelectedTab(key);
    };


    const options: CheckboxGroupProps<string>['options'] = [
        { label: t('my_products'), value: 'MyProducts' },
        { label: t('purchase_history'), value: 'PurchaseHistory' },
    ];

    const user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user') || '{}') : null;



    return (
        <Layout>
            <Helmet>
                <title>Profile - Inventory</title>
                <meta name="description" content="User inventory of purchased products from the store." />
                <link rel="canonical" href="/stores/inventory" />
                <meta name="keywords" content="Store Inventory, Purchased Products, User Store, Trading Bots Inventory" />
                <meta property="og:title" content="Store - Inventory" />
                <meta property="og:description" content="User inventory of purchased products from the store." />
                <meta property="og:url" content="/stores/inventory" />
                <meta property="og:type" content="website" />
            </Helmet>
            <ConfigProvider
                theme={{
                    token: {
                        colorPrimaryActive: '#E9B460',
                        colorPrimaryHover: '#E9B460',
                        colorPrimary: '#E9B460',
                        borderRadius: 6,
                    },
                    components: {
                        Radio: {
                            // buttonSolidCheckedActiveBg: '#E9B460',
                            // buttonSolidCheckedBg: '#E9B460',
                            // buttonSolidCheckedColor: '#fff',
                            // buttonSolidCheckedHoverBg: '#E9B460',
                        },
                    },
                }}
            >
                <nav className="breadcrumb__container mb-3">
                    <div className="breadcrumb__gradient breadcrumb__gradient--left" data-gradient="left" style={{ display: 'none' }}></div>
                    <ul className="breadcrumb" data-breadcrumb-scroll-container="">
                        <li className="breadcrumb-item"><a href="/accounts-overview">{t('Trader')}</a></li>
                        <li className="breadcrumb-item ">
                            <a href="/profile">
                                {t('Profile')}
                            </a>
                        </li>
                        <li className="breadcrumb-item active">{t('PersonalInformation')}</li>
                    </ul>
                    <div className="breadcrumb__gradient breadcrumb__gradient--right" data-gradient="right" style={{ display: 'none' }}></div>
                </nav>

                <div className="section-header mb-4">
                    <div className="section-title">
                        <div className="section-title__title-wrap">
                            <div className="section-title__icon">
                                <i className="fi fi--user fi--themed"></i>
                            </div>
                            <div className="section-title--main">{t('Profile')}</div>
                        </div>
                    </div>
                    <div className="section-header__tabs">
                        <ul className="nav nav-tabs">
                            <li className="nav-item">
                                <a href="/profile" className="nav-link ">
                                    <span className="nav-link__label">{t('PersonalInformation')}</span>
                                </a>
                            </li>
                            <li className="nav-item">
                                <a href="/profile/account" className="nav-link ">
                                    <span className="nav-link__label">{t('AccountInformation')}</span>
                                </a>
                            </li>
                            <li className="nav-item">
                                <a href="/profile/security" className="nav-link ">
                                    <span className="nav-link__label">{t('Security')}</span>
                                </a>
                            </li>
                            {/* <li className="nav-item">
                                <a href="/profile/teams" className="nav-link ">
                                    <span className="nav-link__label">{t('Teams')}</span>
                                </a>
                            </li> */}
                            <li className="nav-item">
                                <a href="/profile/affiliate" className="nav-link ">
                                    <span className="nav-link__label">{t('Affiliates')}</span>
                                </a>
                            </li>
                            <li className="nav-item">
                                <a href="/profile/inventory" className="nav-link active">
                                    <span className="nav-link__label">{t('Inventory')}</span>
                                </a>
                            </li>
                            <li className="nav-item" style={{ pointerEvents: 'none', cursor: 'default', color: 'gray', opacity: '0.6' }}>
                                <a href="#" data-notification-target="nav-profile-identity" className="nav-link disabled" tabIndex={-1} aria-disabled="true">
                                    <span className="nav-link__label">{t('LUMIRIdentity')}</span>
                                </a>
                            </li>
                            <li className="nav-item" style={{ pointerEvents: 'none', cursor: 'default', color: 'gray', opacity: '0.6' }}>
                                <a href="#" className="nav-link disabled" tabIndex={-1} aria-disabled="true">
                                    <span className="nav-link__label">{t('EmailNewsletters')}</span>
                                </a>
                            </li>
                            <li className="nav-item" style={{ pointerEvents: 'none', cursor: 'default', color: 'gray', opacity: '0.6' }}>
                                <a href="#" className="nav-link disabled" tabIndex={-1} aria-disabled="true">
                                    <span className="nav-link__label">{t('LUMIRPoints')}</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="container mx-auto px-4 py-8 rounded-[3px] border border-gray-200 " >
                    <p>
                        {t("coming_soon_notification")}
                    </p>
                </div>
                <div className="container inventory-container mx-auto px-4 py-8 rounded-[3px] border border-gray-200 ">
                    <Radio.Group
                        block
                        options={options}
                        onChange={(e) => handleTabChange(e.target.value)}
                        defaultValue="MyProducts"
                        optionType="button"
                        buttonStyle="solid"

                    />
                    <div className="mt-6">
                        {selectedTab === 'MyProducts' && <StoreInventoryItem />}
                        {selectedTab === 'PurchaseHistory' && <InventoryBuyHistory />}
                    </div>
                </div>
            </ConfigProvider>
        </Layout>
    );
};

export default StoreUserInventory;